var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TooltipStyled',{attrs:{"is-top":_vm.isTopTooltip,"title":_vm.textTooltip}},[_c('v-icon',{attrs:{"color":_vm.colorIcon,"disabled":_vm.isDisabled,"size":_vm.sizeIcon},on:{"click":function($event){return _vm.$emit('click-icon')}}},[_vm._v(" "+_vm._s(_vm.iconText)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }